import { DataTable, Loading } from "@aidkitorg/component-library";
import { Rubric } from "@aidkitorg/types/lib/survey";
import { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { usePost } from "../../API";

export function RubricDirectory() {
  const getAllRubrics = usePost('/program/admin/rubrics/scan');

  const [rubrics, setRubrics] = useState<Rubric[]>([]);

  const history = useHistory();
  const [loadingAllRubrics, setLoadingAllRubrics] = useState(false);
  const searchTimer = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (searchTimer.current) clearTimeout(searchTimer.current);
    setLoadingAllRubrics(true);
    searchTimer.current = setTimeout(async () => {
      const rubrics = await getAllRubrics({});
      if (rubrics.items && Array.isArray(rubrics.items)) {
        setRubrics(rubrics.items);
      } else {
        setRubrics([]);
      }
      setLoadingAllRubrics(false);
    }, 500);
    return () => {
      if (searchTimer.current) clearTimeout(searchTimer.current);
    }
  }, []);

  return <div className="mt-4 bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg space-y-4 p-2">
    <div className="flex flex-col space-y-2">
      <h2 className="text-lg font-semibold">Directory</h2>
      <Loading loading={loadingAllRubrics}>
        <DataTable 
          enableSearch={true}
          searchLabel="Search by name"
          columns={[{
            accessorKey: 'name',
            header: 'Name',
          }, {
            accessorKey: 'version',
            header: 'Version',
          }, {
            accessorKey: 'description',
            header: 'Description',
          }]}
          data={rubrics}
          actions={[{
            label: 'Edit',
            onClick: (row) => {
              history.push(`/ai/config/rubrics?name=${row.name}&version=${row.version}`);
            }
          }]}
        />
      </Loading>
    </div>
  </div>
}